import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { 
  FaArrowRight, FaCloudSun, FaSeedling, FaTint, 
  FaRupeeSign, FaExclamationCircle, FaPlay, FaTimes
} from 'react-icons/fa';
import './Landing.css';

const Landing = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const currentLang = i18n.language || 'mr';

  const [showVideoModal, setShowVideoModal] = useState(false);

  const getText = (hi, mr, en) => {
    if (currentLang === 'mr') return mr || hi;
    if (currentLang === 'hi') return hi;
    return en || hi;
  };

  const riskFactors = [
    { id: 'weather', icon: <FaCloudSun />, name_en: 'Weather', name_hi: 'मौसम', name_mr: 'हवामान' },
    { id: 'soil', icon: <FaSeedling />, name_en: 'Soil', name_hi: 'मिट्टी', name_mr: 'माती' },
    { id: 'water', icon: <FaTint />, name_en: 'Water', name_hi: 'पानी', name_mr: 'पाणी' },
    { id: 'market', icon: <FaRupeeSign />, name_en: 'Market', name_hi: 'मार्केट', name_mr: 'बाजार' },
    { id: 'spoilage', icon: <FaExclamationCircle />, name_en: 'Spoilage', name_hi: 'पोस्ट-हार्वेस्ट', name_mr: 'साठवणूक' }
  ];

  const showcaseCards = [
    {
      title: getText('मौसम', 'हवामान', 'Weather'),
      desc: getText('जलवायु पैटर्न व पूर्वानुमान', 'हवामान अंदाज व विश्लेषण', 'Climate patterns & forecasts'),
      img: 'https://lh3.googleusercontent.com/aida/AP1WRLtS59tIBFWaNm9j2pLhWyUZbh_q-CpgDXIrFH84VJf7CkgFqnKWpYkUYxnWsxFd1JHaKB_njFDcivHpX_YVXfEdXDkIcsvRSUYJzXLo6bySP7q9gkwD9hnBsuTEeBHd4A2Hh3sahEQoD1wD6hvvzbqbqdojuRQY-NxrE4dshwCAtxoWFQSz1RxmV4-W0Xu7ItpY6B2WMBCilqW9bbpm7BHTN2ZBdzSWxWIAV48ovDdA2i7CXWW__GKUOA',
      offsetClass: 'card-offset-1'
    },
    {
      title: getText('मिट्टी स्वास्थ्य', 'मातीचे आरोग्य', 'Soil Health'),
      desc: getText('उर्वरकता व रासायनिक विश्लेषण', 'सुपीकता व NPK विश्लेषण', 'Fertility & composition analysis'),
      img: 'https://lh3.googleusercontent.com/aida/AEtjO1UL-vNuxPdTWn84kVaH-FJMsqQKEhZFKvHstRE9ePuYjPgxL3ZtCewnnfj2Yubz-sxvHU6gt-edWt6PBALtfBCI4GcHFFc2gKk5GDpogM0oETSWEUZ7xiz3NFESEe-PvFgJyEFRNZ1KV3CZZqIEnuQqjSvahotBTyB5eNUtAPVjMV1MeTr0YAno1QazyjieJqfdboZvopfQcEHiHWYVHu8B7ab1IKZA92sS2csfEK3X8G9ieIrP5bNzXDc',
      offsetClass: 'card-offset-2'
    },
    {
      title: getText('जल प्रबंधन', 'पाणी व सिंचन', 'Water'),
      desc: getText('सिंचाई व भूजल प्रबंधन', 'सिंचन व जलस्रोत व्यवस्थापन', 'Irrigation & resource management'),
      img: 'https://lh3.googleusercontent.com/aida/AP1WRLuf4CCCpFNKe4_A7Z2wdfLTPb5uOTVogSFmWZiHhEnPYLa7pM8bvJ-Ku7YEcsoW1mZzt3uaAk4N74lHLSm1G2AZvnHlosoWjarJTwY91gaZTx5FBrGpgMc8LmQBXfoY84IT_wEbPp82FGHaWsmwSjliwmjvPa0zyRXpWaakhhFWZqXFoAzKcwsr0O6U3DJiCmXmNxFc4Cy60vgGBssZhZhCg8Ga13umxmf8rp59Ruomzox6--vkDygvSA',
      offsetClass: 'card-offset-3'
    },
    {
      title: getText('मंडी भाव', 'थेट बाजार भाव', 'Market'),
      desc: getText('मूल्य रुझान व एपीएमसी अंतर्दृष्टि', 'किंमत कल व बाजार विश्लेषण', 'Price trends & mandi insights'),
      img: 'https://lh3.googleusercontent.com/aida/AP1WRLsCEIPSdfQ-d12yUPTlQKyTGYPSQ_EOeUBWFfT4pZfo1HXhev2UXQ-rVI3F3N4auX6ZOKrxkck2c-GdI8W317WC6UajPpe3JPq57UBnfYwieDkePwDoDHL6LJTm5YruoCvEh70iDh8FShmEbdn0ANkGcGn6wRCZ9aXXfx0qFT1CBEazTA2a_9rtRAuTbX_KZWGEXJbF6YlKXr3e1eoNXJF0VwCCH2rtdWv0D1I0PbAVeBGHHa5kwIbUf5o',
      offsetClass: 'card-offset-4'
    },
    {
      title: getText('पोस्ट-हार्वेस्ट', 'कापणीनंतर जोखीम', 'Spoilage'),
      desc: getText('भंडारण व सड़ांध जोखिम नियंत्रण', 'साठवणूक नुकसान प्रतिबंध', 'Post-harvest risk mitigation'),
      img: 'https://lh3.googleusercontent.com/aida/AP1WRLsQu6j-UTUkcjcefNTf2GKkNWe--KQ2hiV2a3Lw9vJqAbC-Z_TMGuNvoaZTOogT541_rXksFfJ-7NI7IXblYRas8q6rKxLar4V-5Yi2TPaYNgset8LIsN5gGiwyb5aeSm1OLQslu7wCmwEZl_zwjVO2ZUjFz44UZ5nrila0sSK4ct5FpyPldpbEoCv0a1DMeQnwRoV9dt73V40kcxxBjCXTNn1VwYP63KZRx169e5K-aOq23Q2WHMca8AI',
      offsetClass: 'card-offset-5'
    }
  ];

  const workflowSteps = [
    {
      step: '01',
      title: getText('डेटा एकत्रीकरण', 'माहिती संकलन', 'Data Collection'),
      desc: getText('उपग्रह, IMD हवामान, ICAR माती व थेट APMC मंडी भाव संकलन.', 'उपग्रह, IMD हवामान, ICAR माती व थेट APMC बाजारभाव संकलन.', 'Live satellite, IMD weather, ICAR soil & Agmarknet APMC mandi feeds.'),
      icon: '📡'
    },
    {
      step: '02',
      title: getText('५-घटक रिस्क गणना', '५-घटक रिस्क गणना', '5-Factor DRI Engine'),
      desc: getText('हवामान, माती, पाणी, बाजार व साठवणूक या ५ स्तंभांवर ०-१०० गणितीय विश्लेषण.', 'हवामान, माती, पाणी, बाजार व साठवणूक या ५ स्तंभांवर ०-१०० गणितीय विश्लेषण.', 'Mathematical 0-100 Distress Risk Index across 5 vital dimensions.'),
      icon: '🧠'
    },
    {
      step: '03',
      title: getText('ग्लास-बॉक्स स्पष्टीकरण', 'ग्लास-बॉक्स स्पष्टीकरण', 'Glass-Box Reasoning'),
      desc: getText('कोणत्या घटकामुळे किती धोका वाढला याचे टक्केवारीत स्पष्टीकरण (उदा. पाऊस -३५%).', 'कोणत्या घटकामुळे किती धोका वाढला याचे टक्केवारीत स्पष्टीकरण (उदा. पाऊस -३५%).', 'Clear transparent breakdown of risk drivers in local language.'),
      icon: '🔍'
    },
    {
      step: '04',
      title: getText('तात्काळ कृती आराखडा', 'तात्काळ कृती आराखडा', 'Action Checklist'),
      desc: getText('पुढील २४-४८ तासांत नेमके काय करावे याचे तज्ज्ञ मार्गदर्शन.', 'पुढील २४-४८ तासांत नेमके काय करावे याचे तज्ज्ञ मार्गदर्शन.', 'Prioritized 24-48h intervention advisory for farm and crop.'),
      icon: '⚡'
    },
    {
      step: '05',
      title: getText('सरकारी योजना व विमा', 'सरकारी योजना व विमा', 'Welfare & Claims'),
      desc: getText('PMFBY पीक विमा, PM किसान व आपत्कालीन सवलतींसाठी थेट अर्ज जोडणी.', 'PMFBY पीक विमा, PM किसान व आपत्कालीन सवलतींसाठी थेट अर्ज जोडणी.', 'Automated pre-filled claim matching with PMFBY & Govt schemes.'),
      icon: '🏛️'
    }
  ];

  return (
    <div className="fd-landing-wrap">
      {/* Hero Section */}
      <section className="fd-new-hero">
        <div className="fd-hero-bg-image">
          <img 
            src="https://lh3.googleusercontent.com/aida-public/AB6AXuDrlF2fx73pHt1LPYzMkOGhlLY7j_HUyVGz5PmaFXtQ4EmLhoj0CoNeZ3XAM6x0JRgcfwYbh7cjUbeT7Rsqzpah9PVFINiN5bTwxCVTJqP9O8lmKs6MMkCYp1xEkEC5WBgc4WLkvdMuKb31K1va2ZsPkGVjzs7fDhUbKj3UJs9vAPONNFIy7gBC_6hATGkbFaymqEUikJ612hrY9Cp4_cVKEWBgg8e-k5QlRA_TddNCoyDk-GuWJ-rppYm2oFgobXVCww" 
            alt="Farmer in lush field" 
          />
          <div className="fd-hero-overlay"></div>
        </div>

        <div className="fd-hero-container">
          <div className="fd-hero-content">
            <h1 className="fd-hero-title">
              {getText('मेरी फसल,', 'माझी शेती,', 'Meri Fasal,')}<br />
              <span className="fd-title-green">{getText('मेरा रिस्क,', 'माझा धोका,', 'Mera Risk,')}</span><br />
              {getText('मेरा फैसला।', 'माझा निर्णय.', 'Mera Faisla.')}
            </h1>

            <p className="fd-hero-sub">
              “{getText(
                'अपनी फसल को संकट से बचाने के लिए जोखिम की जांच करें।',
                'आपल्या पिकाला संकटापासून वाचवण्यासाठी धोका तपासा.',
                'Apni fasal ko distress se bachane ke liye risk check karein.'
              )}”
            </p>

            <div className="fd-hero-actions">
              <Link to="/check-risk" className="fd-btn-primary-hero">
                <span>{getText('फसल जोखिम जांचें', 'पीक धोका तपासा', 'Check My Crop Risk')}</span>
                <FaArrowRight className="fd-btn-arrow" />
              </Link>
              <button 
                className="fd-btn-secondary-hero"
                onClick={() => setShowVideoModal(true)}
              >
                <FaPlay className="fd-play-icon" />
                <span>{getText('वीडियो देखें', 'व्हिडिओ पहा', 'Watch Video')}</span>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* 5 Risk Factors Horizontal Strip */}
      <section className="fd-risk-strip-section">
        <div className="fd-strip-container">
          <div className="fd-strip-grid">
            {riskFactors.map((f) => (
              <div key={f.id} className="fd-strip-card" onClick={() => navigate('/check-risk')}>
                <div className="fd-strip-icon-circle">
                  {f.icon}
                </div>
                <span className="fd-strip-card-name">
                  {currentLang === 'mr' ? f.name_mr : (currentLang === 'hi' ? f.name_hi : f.name_en)}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Agricultural Showcase Section */}
      <section className="fd-showcase-section" id="features">
        <div className="fd-showcase-container">
          <div className="fd-showcase-grid">
            {showcaseCards.map((card, idx) => (
              <div 
                key={idx} 
                className={`fd-showcase-card ${card.offsetClass}`}
                onClick={() => navigate('/check-risk')}
              >
                <img src={card.img} alt={card.title} className="fd-showcase-img" />
                <div className="fd-showcase-gradient"></div>
                <div className="fd-showcase-info">
                  <h3>{card.title}</h3>
                  <p>{card.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How It Works Section - 5 Step Flow Cards */}
      <section className="fd-how-it-works-section" id="how-it-works">
        <div className="fd-how-container">
          <div className="fd-how-header">
            <span className="fd-how-badge">{getText('कार्यप्रणाली', 'कार्यप्रणाली', 'SYSTEM ARCHITECTURE')}</span>
            <h2>{getText('Fasal Drishti कसे काम करते?', 'Fasal Drishti कसे काम करते?', 'How Fasal Drishti Works')}</h2>
            <p>{getText('डेटा एकत्रीकरणापासून ते तात्काळ कृती आणि नुकसान प्रतिबंधापर्यंतचा ५-टप्प्यांचा चक्र.', 'डेटा एकत्रीकरणापासून ते तात्काळ कृती आणि नुकसान प्रतिबंधापर्यंतचा ५-टप्प्यांचा चक्र.', 'The 5-stage closed loop: Detect • Explain • Act • Track')}</p>
          </div>

          <div className="fd-how-steps-grid">
            {workflowSteps.map((step, idx) => (
              <div key={step.step} className="fd-how-step-card">
                <div className="fd-how-step-top">
                  <span className="fd-how-step-num">{step.step}</span>
                  <span className="fd-how-step-icon">{step.icon}</span>
                </div>
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
                {idx < workflowSteps.length - 1 && (
                  <div className="fd-step-connector-line"></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Us Section */}
      <section className="fd-about-us-section" id="about" style={{ padding: '60px 20px', background: '#f8fafc', borderTop: '1px solid #e2e8f0' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <span style={{ fontSize: '12px', fontWeight: 800, color: '#059669', background: '#ecfdf5', padding: '6px 14px', borderRadius: '20px' }}>
              {getText('आमच्याबद्दल', 'हमारे बारे में', 'ABOUT FASAL DRISHTI')}
            </span>
            <h2 style={{ fontSize: '28px', fontWeight: 800, color: '#064e3b', marginTop: '12px' }}>
              {getText('शेतकऱ्यांना संकटापासून वाचवणारी भारताची पहिली AI प्रणाली', 'किसानों को संकट से बचाने वाली भारत की पहली AI प्रणाली', 'India’s 1st Multidimensional Farmer Distress Prediction Platform')}
            </h2>
            <p style={{ maxWidth: '750px', margin: '10px auto 0 auto', color: '#64748b', fontSize: '15px' }}>
              {getText(
                'Fasal Drishti उपग्रह, IMD हवामान, ICAR माती डेटा आणि थेट APMC बाजारभावाचे विश्लेषण करून पिकाचे संभाव्य नुकसान होण्यापूर्वीच शेतकऱ्याला सावध करते.',
                'Fasal Drishti सैटेलाइट, मौसम, ICAR मिट्टी और APMC मंडी भाव का विश्लेषण करके फसल को संकट से बचाती है।',
                'Fasal Drishti integrates satellite NDVI, IMD weather radar, ICAR soil baselines, and APMC wholesale data to provide glass-box predictive distress intelligence before loss occurs.'
              )}
            </p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px' }}>
            <div style={{ background: '#fff', padding: '24px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
              <div style={{ fontSize: '28px', marginBottom: '10px' }}>🔬</div>
              <h3 style={{ fontSize: '17px', fontWeight: 800, color: '#064e3b', marginBottom: '8px' }}>
                {getText('वैज्ञानिक ५-घटक विश्लेषण', 'वैज्ञानिक 5-कारक विश्लेषण', '5-Factor Mathematical Model')}
              </h3>
              <p style={{ fontSize: '13.5px', color: '#64748b', lineHeight: '1.6' }}>
                {getText('केवळ हवामान नव्हे तर माती, पाणी, बाजार भाव आणि साठवणूक या ५ स्तंभांवर मोजणी.', 'सिर्फ मौसम ही नहीं, बल्कि मिट्टी, पानी, बाजार और भंडारण का समग्र विश्लेषण।', 'Analyzes weather stress, soil nutrition, irrigation limits, APMC price drops, and perishability decay.')}
              </p>
            </div>

            <div style={{ background: '#fff', padding: '24px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
              <div style={{ fontSize: '28px', marginBottom: '10px' }}>🛡️</div>
              <h3 style={{ fontSize: '17px', fontWeight: 800, color: '#064e3b', marginBottom: '8px' }}>
                {getText('CIBRC प्रमाणित सुरक्षा', 'CIBRC प्रमाणित सुरक्षा', 'Zero-Hallucination Safe Advice')}
              </h3>
              <p style={{ fontSize: '13.5px', color: '#64748b', lineHeight: '1.6' }}>
                {getText('कोणतीही चुकीची रासायनिक औषध शिफारस रोखण्यासाठी ICAR व CIBRC प्रमाणित डेटाबेस.', 'फसलों को नुकसान से बचाने के लिए केवल सरकारी प्रमाणित रसायनों और जैविक उपायों की सलाह।', 'All spray guidance is strictly hard-locked to CIBRC & ICAR certified active ingredients and safe weather windows.')}
              </p>
            </div>

            <div style={{ background: '#fff', padding: '24px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
              <div style={{ fontSize: '28px', marginBottom: '10px' }}>🌾</div>
              <h3 style={{ fontSize: '17px', fontWeight: 800, color: '#064e3b', marginBottom: '8px' }}>
                {getText('स्थानिक पीक प्राधान्य', 'क्षेत्रीय फसल प्राथमिकता', 'Khandesh & Regional Crops')}
              </h3>
              <p style={{ fontSize: '13.5px', color: '#64748b', lineHeight: '1.6' }}>
                {getText('जळगावची GI-Tag केळी, नाशिकचा कांदा, विदर्भाचा कापूस आणि मालव्याचा सोयाबीन यांसाठी विशेष कॅलिब्रेशन.', 'जलगांव का केला, नासिक का प्याज, और सोयाबीन के लिए विशेष रूप से अनुकूलित।', 'Calibrated for Jalgaon Grand Naine Banana, Nashik Onion, Cotton, and Soybean clusters.')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="fd-contact-us-section" id="contact" style={{ padding: '60px 20px', background: '#064e3b', color: '#fff' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', textAlign: 'center' }}>
          <span style={{ fontSize: '12px', fontWeight: 800, color: '#a7f3d0', background: 'rgba(255,255,255,0.1)', padding: '6px 14px', borderRadius: '20px' }}>
            {getText('संपर्क व मदत', 'संपर्क एवं सहायता', 'CONTACT & HELPLINE')}
          </span>
          <h2 style={{ fontSize: '28px', fontWeight: 800, color: '#fff', marginTop: '12px' }}>
            {getText('आम्हाला संपर्क करा', 'हमसे संपर्क करें', 'Get in Touch with Fasal Drishti Team')}
          </h2>
          <p style={{ maxWidth: '650px', margin: '10px auto 30px auto', color: '#a7f3d0', fontSize: '15px' }}>
            {getText('२४/७ शेतकरी हेल्पलाइन, कृषी विज्ञान केंद्र आणि तांत्रिक सहकार्य उपलब्ध.', '24/7 किसान हेल्पलाइन, कृषि विज्ञान केंद्र और तकनीकी सहायता उपलब्ध।', '24/7 Farmer helpline, KVK agronomist support, and technical assistance.')}
          </p>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px', textAlign: 'left' }}>
            <div style={{ background: 'rgba(255,255,255,0.08)', padding: '24px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.15)' }}>
              <h4 style={{ fontSize: '16px', fontWeight: 800, color: '#a7f3d0', marginBottom: '8px' }}>📞 {getText('टोल-फ्री हेल्पलाइन', 'टोल-फ्री हेल्पलाइन', 'Toll-Free Helpline')}</h4>
              <p style={{ margin: '0 0 4px 0', fontSize: '18px', fontWeight: 800 }}>1800-180-1551</p>
              <span style={{ fontSize: '12px', color: '#93c5fd' }}>Kisan Call Center (6:00 AM - 10:00 PM)</span>
            </div>

            <div style={{ background: 'rgba(255,255,255,0.08)', padding: '24px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.15)' }}>
              <h4 style={{ fontSize: '16px', fontWeight: 800, color: '#a7f3d0', marginBottom: '8px' }}>📧 {getText('ईमेल संपर्क', 'ईमेल संपर्क', 'Email Support')}</h4>
              <p style={{ margin: '0 0 4px 0', fontSize: '16px', fontWeight: 700 }}>support@fasaldrishti.in</p>
              <span style={{ fontSize: '12px', color: '#a7f3d0' }}>Response within 2-4 hours</span>
            </div>

            <div style={{ background: 'rgba(255,255,255,0.08)', padding: '24px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.15)' }}>
              <h4 style={{ fontSize: '16px', fontWeight: 800, color: '#a7f3d0', marginBottom: '8px' }}>📍 {getText('मुख्यालय', 'मुख्यालय', 'Headquarters')}</h4>
              <p style={{ margin: '0 0 4px 0', fontSize: '14px', fontWeight: 700 }}>Jalgaon - 425002, Maharashtra, India</p>
              <span style={{ fontSize: '12px', color: '#a7f3d0' }}>Khandesh AgriTech Innovation Cluster</span>
            </div>
          </div>
        </div>
      </section>

      {/* Video Modal */}
      {showVideoModal && (
        <div className="fd-video-modal-backdrop" onClick={() => setShowVideoModal(false)}>
          <div className="fd-video-modal-card" onClick={(e) => e.stopPropagation()}>
            <button className="fd-video-close-btn" onClick={() => setShowVideoModal(false)}>
              <FaTimes />
            </button>
            <div className="fd-video-wrapper">
              <iframe 
                src="https://www.youtube.com/embed/c-SdpcAczoo?si=4INPMHloHrMM21S1&autoplay=1" 
                title="YouTube video player" 
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                referrerPolicy="strict-origin-when-cross-origin" 
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Landing;
